/**
 * AdminSettingsPage (Plan 03-08) — tabbed admin settings surface at /admin/settings.
 *
 * Tab 1 (Compliance): ConsentVersionEditorTab — Ley 8968 consent-version management.
 * Future tabs (Phase 4 image-rights consent, Phase 5 retention config) slot in here.
 *
 * Route access (App.tsx): wrapped in RequireRole for content_admin + super_admin.
 * RequireRole gives the page-level 403 surface for hr roles + hiring_manager, so this
 * component needs NO in-page redirect (mirrors /admin/candidates/:id, Plan 03-07).
 * super_admin reaches the page read-only; the Save button is canMutate-gated (D7).
 */
import { useTranslation } from "react-i18next";

import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

import { ComplianceConfigTab } from "./ComplianceConfigTab";
import { ConsentVersionEditorTab } from "./ConsentVersionEditorTab";

export function AdminSettingsPage() {
  const { t } = useTranslation("admin-settings");

  return (
    <div className="mx-auto w-full max-w-5xl px-4 py-6 space-y-4">
      <div>
        <h1 className="text-xl font-bold">{t("page.title")}</h1>
        <p className="text-sm text-[var(--talenta-text-muted)]">
          {t("page.subtitle")}
        </p>
      </div>

      <Tabs defaultValue="config">
        <TabsList>
          <TabsTrigger value="config">{t("page.tabs.config")}</TabsTrigger>
          <TabsTrigger value="consent">{t("page.tabs.consent")}</TabsTrigger>
        </TabsList>
        <TabsContent value="config">
          <ComplianceConfigTab />
        </TabsContent>
        <TabsContent value="consent">
          <ConsentVersionEditorTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
